import { render, staticRenderFns } from "./SetReminder.vue?vue&type=template&id=53fdb191"
import script from "./SetReminder.vue?vue&type=script&lang=js"
export * from "./SetReminder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports